import React from 'react';
import Classes from './styles/style.module.css';
import Logo from '../Home/Components/Logo/Logo';

function TermsOfService() {
    return (
        <>
            <div className={Classes.navContainer} style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.06)' }} >
                <div>
                    <a className={Classes.logoLink} href="/">
                        <Logo alwaysShowText={true} />
                    </a>
                </div>
                <nav className={Classes.navMenu}>

                </nav>
                <div>
                    <a href="/">
                        <h5 className={Classes.goBackTxt} >Go back to Privacybot.com</h5>
                    </a>
                </div>
            </div>
            <div className={Classes.hero}>
                <h1>Terms of Service</h1>
                <div className={Classes.form_con}>
                    <h5>Effective Date: May 11th, 2025</h5>
                    <br />
                    <h5>
                        Welcome to <a href='https://privacybot.com' target='_blank' rel='noopener noreferrer'>privacybot.com</a> ("PrivacyBot", "we", "us," or "our"). These Terms of Service ("Terms") govern your access to and use of our website, platform, products, and services (collectively, the "Services").
                        <br /><br />
                        By using the Services, you agree to be bound by these Terms and our Privacy Policy.
                        <br /><br />
                        If you do not agree with these Terms, you may not access or use the Services.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>1. Services Overview</h5>
                    <h5>
                        privacybot.com provides agencies with tools to onboard and manage clients, projects, tasks, payments, and communications seamlessly. Our Services are designed to streamline client operations and agency workflows.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>2. Eligibility</h5>
                    <h5>
                        You must be at least 18 years old and able to form a legally binding contract to use our Services. By using privacybot.com, you represent and warrant that you meet these requirements.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>3. Your Account</h5>
                    <h5>
                        You must create an account to access certain features of the Services.
                        <br /><br />
                        You are responsible for maintaining the confidentiality of your login credentials and for any activities under your account.
                        <br /><br />
                        You agree to provide accurate, current, and complete information when creating your account.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>4. Use of Services</h5>
                    <h5>When using privacybot.com, you agree to:</h5>
                    <br />
                    <ul>
                        <li>
                            <h5>Use the Services only for lawful purposes and in accordance with these Terms.</h5>
                        </li>
                        <li>
                            <h5>Not upload or share any content that is unlawful, abusive, or infringes on third-party rights.</h5>
                        </li>
                        <li>
                            <h5>Not attempt to interfere with the operation or security of the Services.</h5>
                        </li>
                    </ul>
                    <br />
                    <h5>
                        We reserve the right to suspend or terminate accounts that violate these Terms.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>5. Payment Terms</h5>
                    <ul>
                        <li>
                            <h5>Some features of privacybot.com may require payment of fees.</h5>
                        </li>
                        <li>
                            <h5>By subscribing to a paid plan, you agree to pay all applicable fees and taxes.</h5>
                        </li>
                        <li>
                            <h5>Payments are non-refundable except as expressly stated in our Refund Policy.</h5>
                        </li>
                        <li>
                            <h5>We may modify pricing at any time. Changes will be communicated to you in advance.</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>6. Intellectual Property</h5>
                    <ul>
                        <li>
                            <h5>All content, software, and materials provided by privacybot.com are owned by us or our licensors.</h5>
                        </li>
                        <li>
                            <h5>You are granted a limited, non-exclusive, non-transferable license to use the Services solely for your agency's internal business purposes.</h5>
                        </li>
                        <li>
                            <h5>You may not copy, modify, distribute, sell, or lease any part of our Services without our written consent.</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>7. User Content</h5>
                    <ul>
                        <li>
                            <h5>You retain ownership of any content you submit, upload, or create using privacybot.com.</h5>
                        </li>
                        <li>
                            <h5>You grant privacybot.com a limited license to host, store, and display your content solely to provide the Services.</h5>
                        </li>
                        <li>
                            <h5>We do not claim ownership of your data.</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>8. Third-Party Services</h5>
                    <h5>
                        privacybot.com may integrate with third-party tools and services. We are not responsible for the content, policies, or practices of third-party services.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>9. Disclaimers</h5>
                    <ul>
                        <li>
                            <h5>The Services are provided "as is" and "as available."</h5>
                        </li>
                        <li>
                            <h5>We make no warranties, express or implied, regarding the Services, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.</h5>
                        </li>
                        <li>
                            <h5>We do not guarantee that the Services will always be secure, uninterrupted, or error-free.</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>10. Limitation of Liability</h5>
                    <ul>
                        <li>
                            <h5>To the maximum extent permitted by law, privacybot.com shall not be liable for any indirect, incidental, special, consequential, or punitive damages.</h5>
                        </li>
                        <li>
                            <h5>Our total liability for any claims related to the Services shall not exceed the amount paid by you to privacybot.com in the past 12 months.</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>11. Indemnification</h5>
                    <h5>
                        You agree to indemnify and hold harmless privacybot.com, its affiliates, officers, agents, and employees from any claims, damages, liabilities, costs, or expenses arising from your use of the Services or your violation of these Terms.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>12. Termination</h5>
                    <h5>
                        We may suspend or terminate your access to the Services at any time, with or without cause or notice. Upon termination, your right to use the Services will immediately cease.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>13. Changes to These Terms</h5>
                    <h5>
                        We may update these Terms from time to time. If we make material changes, we will provide notice through the Services or by other means.
                        <br /><br />
                        Your continued use of the Services after the effective date of any changes constitutes your acceptance of the revised Terms.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>14. Governing Law</h5>
                    <h5>
                        These Terms are governed by the laws of the State of New York, without regard to conflict of laws principles.
                        <br /><br />
                        Any disputes shall be resolved exclusively in the state or federal courts located in New York.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>15. Contact Us</h5>
                    <h5>
                        If you have any questions about these Terms, please contact us at:
                        <br /><br />
                        privacybot.com
                        <br />
                        Support@privacybot.com
                    </h5>
                    <br />
                </div>
            </div>
        </>
    );
}

export default TermsOfService;
